/**
 * 账号设置
 *
 **/

import React from 'react';
import { Button, Card, Col, Form, Icon, Input, message, Modal, Popconfirm, Row, Select, Spin, Tabs } from 'antd';
import { findUserDefault, updateUserDefault, removeUser } from "../../services/user";
import { fetchLoginedUser } from "../../redux/actions/user";
import { updateModifypasswd } from "../../services/userPwd";
import {
    BizRegex,
    clearAuth,
    getPrematchEmail,
    getPrematchMobile,
    MsgActionType,
    sendEmailCaptcha,
    sendSmsCaptcha,
    setResetEmail,
    setResetMobile,
    isSuperuser
} from "../../services/global";
import CkUpload from "../../components/CkUpload";
import UserAddressesSetting from "../user/UserAddressesSetting";
import UserSmssignSetting from "../user/UserSmssignSetting";
import SubAccounts from "./SubAccounts";
import CreditSystemConfigs from "./CreditSystemConfigs";
import CreditSystemStatus from "./CreditSystemStatus";
import WxAuthorization from "./WxAuthorization";
import SubAccountEvtApplyList from "../subaccount/SubAccountEvtApplyList";
import { fetchUserAddresses } from "../../redux/actions/userAddress";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import CountDownText from "../../components/countdown/CountDownText";
import { findOnlineUserTokens, kickOnlineUserExcludeOneself, kickOnlineUserToken, kickOnlineUser } from "../../services/onlineUser";
import styled from "styled-components";
import { findInvoiceBook, updateInvoiceBook } from "../../services/invoice";

const ASBody = styled.span`
    .ant-tabs-tabpane{
      min-height: 500px;
    }
`;
const WFBody = styled.div`
    >h5{
      font-size:24px;
    }
    >p{
      font-size:14px;
      color:#999;
      margin:5px 0 30px 0;
    }
    >div{
      font-size:16px;
      display: flex;
      align-items: center;
      >span{
        display:inline-block;
        width:8px;
        height:8px;
        border-radius:8px;
        background:#434343;
        margin-right:8px;
      }
    }
`;
const WFModal = styled.div`
    font-size:14px;
    >div{
      margin-bottom:30px;
    }
    >p{
      margin-bottom:25px;
    }
`;
class AccountSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tokenValue: '',
            tokenModalVisible: false,
            invBook: { data: {} },
            type: null,
            visible: false,
            countingDone: true,
            confirmDirty: false,
            activiKey: props.activeKey ? props.activeKey : '1',
            mobileActiveKey: '__1',
            emailActiveKey: '__1',
            autoCompleteResult: [],
            userData: {
                isFetching: true,
                data: null,
            },

            userTokens: null
        }


    }

    componentDidMount() {
        this.fetchUserDefault();
        this.props.fetchUserAddresses({ userId: "default" });
        if (this.state.activiKey == '6') {
            findInvoiceBook({ userId: "default" }).then(res => {
                if (res.code === 200) {
                    this.setState({ invBook: res })
                }
            });
        }
    }

    handleTokenModalVisible = (flag) => {
        this.setState({ tokenModalVisible: flag })
    };
    handleWFModalVisible = (flag) => {
        this.setState({ wfModalVisible: flag })
    };
    handleWFCapVisible = (flag) => {
        this.setState({ wfCapVisible: flag })
    };

    handleTokenSubmit = () => {
        const { tokenValue } = this.state;
        localStorage.setItem('token', tokenValue);
        this.handleTokenModalVisible(false);
    };

    findDefaultOnlineUserTokens = () => {
        this.setState({
            userTokens: null,
        }, () => {
            findOnlineUserTokens({ userId: "default" }).then(res => {
                if (res.code == 200) {
                    this.setState({
                        userTokens: res.data,
                    })
                } else {
                    message.error(res.msg,6);
                }
            }).catch(err => {
                message.warn("访问异常");
            }).finally(() => {
            })
        })

    }

    fetchUserDefault = () => {
        findUserDefault().then(res => {
            if (res.code == 200) {
                let mobileKey = res.data.mobile && res.data.mobile !== '' ? '__1' : '__2';
                let emailKey = res.data.email && res.data.email !== '' ? '__1' : '__2';
                this.setState({
                    mobileActiveKey: mobileKey,
                    emailActiveKey: emailKey,
                    userData: {
                        isFetching: false,
                        data: res.data,
                    }
                })
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        }).finally(() => {
        })
    }
    onSubmit = () => {
        this.props.form.validateFieldsAndScroll(['avatarUrl', 'nickname', 'qq', 'company', 'gender'], (err, values) => {
            if (!err) {
                updateUserDefault(values).then(res => {
                    if (res.code == 200) {
                        message.info("修改成功!");
                        //刷新下store的登录用户信息
                        this.props.fetchLoginedUser();
                        // this.props.visibleHide();
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                })
            } else {
                console.log('no: ', values);
            }
        });
    };
    onInvoiceSubmit = () => {
        this.props.form.validateFieldsAndScroll(['companyName', 'companyTaxNo', 'companyAddress', 'companyPhone', 'bankName', 'bankAccount'], (err, values) => {
            if (!err) {
                updateInvoiceBook(Object.assign({}, { userId: 'default' }, values)).then(res => {
                    if (res.code === 200) {
                        message.success("保存成功!");
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => message.warn("访问异常"));
            } else {
                console.log('no: ', values);
            }
        });
    };
    // onSubmitUpdatePwd = () => {
    //     this.props.form.validateFieldsAndScroll(['oldPasswd', "newPasswd"], (err, values) => {
    //         if (!err) {
    //             updateModifypasswd(values).then(res => {
    //                 if (res.code === 200) {
    //                     message.info("修改成功, 请重新登录!");
    //                     // this.handleCancel();
    //                     // this.logout();
    //                     this.kickUser();
    //                 } else {
    //                     message.error(res.msg,6);
    //                 }
    //             }).catch(err => {
    //                 message.warn("访问异常");
    //             }).finally(() => {
    //             })
    //         } else {
    //         }
    //     });
    // }
    //修改密码
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll(['loginUniqueKey', "captcha", "newPasswd"], (err, values) => {
            if (!err) {
                updateModifypasswd(values).then(res => {
                    console.log("createRole res: ", res);
                    if (res.code == 200) {
                        message.info("修改成功, 请重新登录!");
                        this.kickUser();
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {

                })
            }
        })
    };
    //发送忘记密码验证码
    sendCaptchaPwd = () => {
        if (this.state.countingDone) {
            this.props.form.validateFields(["loginUniqueKey"], (err, values) => {
                if (!err) {
                    const loginVal = values.loginUniqueKey;
                    const _sendCaptcha = BizRegex.email.test(loginVal) ? sendEmailCaptcha : sendSmsCaptcha;
                    console.log("values", values)
                    _sendCaptcha(MsgActionType.MODIFY_PASSWD_CPT, loginVal).then(res => {
                        if (res.code == 200) {
                            this.changeCountingDone(false)
                            this.captchaTextComp.start();
                            // if (res.data && res.data.captcha) {
                            //     this.props.form.setFieldsValue({
                            //         "captcha": res.data.captcha
                            //     });
                            // }
                        } else {
                            message.error(res.msg,6);
                        }
                    }).catch(err => {
                        console.log(err);
                        message.warn("访问异常");
                    })
                }
            })
        }
    }
    //pwd
    handleConfirmBlur = (e) => {
        const value = e.target.value;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    }
    checkPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('password')) {
            callback('两次密码输入不一致!');
        } else {
            callback();
        }
    }
    checkConfirm = (rule, value, callback) => {
        const form = this.props.form;
        if (value && this.state.confirmDirty) {
            form.validateFields(['newPasswd'], { force: true });
        }
        callback();
    }
    _checkConfirm = (rule, value, callback) => {
        const form = this.props.form;
        if (value && this.state.confirmDirty) {
            form.validateFields(['newPassword'], { force: true });
        }
        callback();
    };
    kickUser = () => {
        kickOnlineUser({ userId: "default" }).then(res => {
            if (res.code === 200) {
                clearAuth(true);
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })
    };
    //发验证码
    sendCaptcha = (type) => {
        if (this.state.countingDone) {
            this.props.form.validateFields([type], (err, values) => {
                if (!err) {
                    const mobileOrEmailVal = values[type];
                    const _sendCaptcha = type == 'newMobile' || type == 'orignalMobile' ? sendSmsCaptcha : sendEmailCaptcha;
                    let _sendType;
                    if (type == 'orignalMobile') {
                        _sendType = MsgActionType.UNBIND_PHONE;
                    } else if (type == 'newMobile') {
                        _sendType = MsgActionType.BIND_PHONE;
                    } else if (type == 'orignalEmail') {
                        _sendType = MsgActionType.UNBIND_EMAIL;
                    } else {
                        _sendType = MsgActionType.BIND_EMAIL;
                    }
                    _sendCaptcha(_sendType, mobileOrEmailVal).then(res => {
                        if (res.code == 200) {
                            this.changeCountingDone(false)
                            this.captchaTextComp.start();
                        } else {
                            message.error(res.msg,6);
                        }
                    }).catch(err => {
                        message.warn("访问异常");
                    })
                }
            })
        }
    }
    //注销验证码
    sendWFCaptcha = () => {
        if (this.state.countingDone) {
            this.props.form.validateFields(['mobile'], (err, values) => {
                if (!err) {
                    sendSmsCaptcha(MsgActionType.REMOVE_ACCOUNT_CPT, values.mobile).then(res => {
                        if (res.code == 200) {
                            this.changeCountingDone(false)
                            this.captchaTextComp.start();
                        } else {
                            message.error(res.msg,6);
                        }
                    }).catch(err => {
                        message.warn("访问异常");
                    })
                }
            })
        }
    }
    //确认注销
    onSumbitWF = (captcha = null) => {
        let values = captcha ? { captcha } : null;
        removeUser(values).then(res => {
            if (res.code == 200) {
                message.info("注销成功!");
                //刷新下store的登录用户信息
                localStorage.removeItem('token')
                this.props.fetchLoginedUser();
                // this.props.visibleHide();
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        }).finally(() => {
        })
    }
    getWFCaptcha = () => {
        this.props.form.validateFields(['captcha'], (err, values) => {
            if (!err) {
                this.onSumbitWF(values.captcha)
            }
        })
    }
    //匹配验证码
    prematchCaptcha = (mobileOrEmail, captcha) => {
        this.props.form.validateFields([mobileOrEmail, captcha], (err, values) => {
            if (!err) {
                const captchaVal = values[captcha];
                const _sendCaptcha = mobileOrEmail == 'orignalMobile' ? getPrematchMobile : getPrematchEmail;
                let data = {};

                if (mobileOrEmail == 'orignalMobile') {
                    data = { mobile: values[mobileOrEmail], type: MsgActionType.UNBIND_PHONE };
                } else {
                    data = { email: values[mobileOrEmail], type: MsgActionType.UNBIND_EMAIL };
                }
                _sendCaptcha(captchaVal, data).then(res => {
                    if (res.code == 200 && res.data) {
                        this.changeCountingDone(true);
                        mobileOrEmail == 'orignalMobile' ? this.setState({ mobileActiveKey: '__2' }) : this.setState({ emailActiveKey: '__2' })

                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                })
            }
        })
    }
    //重置手机或邮箱
    onSubmitReset = (type) => {
        const { userData } = this.state;
        let arr = [];
        if (type == 'mobile') {
            if (userData.data.mobile) {
                arr = ["newCaptcha", "newMobile", "orignalCaptcha", "orignalMobile"]
            } else if (!userData.data.mobile && userData.data.email) {
                arr = ["newCaptcha", "newMobile"]
            } else {
                arr = ["newCaptcha", "newMobile", "newPassword"]
            }

        } else {
            if (userData.data.email) {
                arr = ["newCaptcha", "newEmail", "orignalCaptcha", "orignalEmail"]
            } else if (!userData.data.email && userData.data.mobile) {
                arr = ["newCaptcha", "newEmail"]
            } else {
                arr = ["newCaptcha", "newEmail", "newPassword"]
            }

        }
        this.props.form.validateFieldsAndScroll(arr, (err, values) => {
            if (!err) {
                const _setReset = type == 'mobile' ? setResetMobile : setResetEmail;
                _setReset(values).then(res => {
                    if (res.code == 200) {
                        this.setState({
                            userData: {
                                isFetching: true,
                                data: null,
                            }
                        })
                        this.changeCountingDone(true);
                        this.fetchUserDefault();
                        //刷新下store的登录用户信息
                        this.props.fetchLoginedUser();
                        this.handleCancel();

                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    console.log(err);
                    message.warn("访问异常");
                })
            } else {
            }
        })

    }
    changeCountingDone = (countingDone) => {
        this.setState({
            countingDone: countingDone
        })
    }
    //
    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
        this.changeCountingDone(true);
    };
    showModal = (type) => {
        this.setState({
            type: type,
            visible: true,
        });
    };
    handleChangeTabs = (val) => {
        switch (val) {
            case '3':
                this.findDefaultOnlineUserTokens();
                break;
            case '6':
                findInvoiceBook({ userId: "default" }).then(res => {
                    if (res.code === 200) {
                        this.setState({ invBook: res })
                    }
                });
                break;
            default:
        }
        this.setState({ activiKey: val });
    };

    render() {
        const { userData } = this.state
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 14,
                    offset: 6,
                },
            },
        };
        const invBook = this.state.invBook;
        const changePwd = <div>
            <Form.Item
                {...formItemLayout}
                label="手机"
                hasFeedback
            >
                {getFieldDecorator('loginUniqueKey', {
                    rules: [
                        { required: true, message: '请输入手机号!' },
                        { pattern: BizRegex.emailOrMobile, message: '请输入手机号!' },
                    ],

                })(
                    <Input placeholder="输入手机号" />
                )}
            </Form.Item>
            <Form.Item
                {...formItemLayout}
                label="验证码"
            >

                <Input.Group size="large">
                    <Col span={15}>
                        {getFieldDecorator('captcha', {
                            rules: [
                                { required: true, message: '请输入验证码!' }
                            ],
                        })(
                            <Input placeholder="验证码" />
                        )}
                    </Col>
                    <Col span={9}>
                        <Button type="primary" className="captcha-btn"
                            onClick={this.sendCaptchaPwd}
                            style={{ width: '100%' }}
                            size="large">
                            <CountDownText
                                ref={(captchaTextComp) => {
                                    this.captchaTextComp = captchaTextComp
                                }}
                                afterEnd={() => {
                                    this.changeCountingDone(true)
                                }}
                                startText='发送验证码'
                                endText='发送验证码'
                                timeLeft={60} // 正向计时 时间起点为0秒
                                intervalText={(sec) => sec + '秒重新获取'} />
                        </Button>
                    </Col>
                </Input.Group>
            </Form.Item>
            <Form.Item
                {...formItemLayout}
                label="新密码"
                hasFeedback
            >
                {getFieldDecorator('newPasswd', {
                    rules: [{
                        required: true, message: '输入你的密码!',
                    },
                    { type: "string", min: 6, max: 20, message: '长度限制为6至20个之间!' },
                        // {validator: this.checkConfirm,}
                    ],
                })(
                    <Input type="password" />
                )}
            </Form.Item>
            {/*<Form.Item*/}
            {/*{...formItemLayout}*/}
            {/*label="确认密码"*/}
            {/*hasFeedback*/}
            {/*>*/}
            {/*{getFieldDecorator('newPasswd', {*/}
            {/*rules: [{*/}
            {/*required: true, message: '输入你的确认密码!',*/}
            {/*},*/}
            {/*{type: "string", min: 6, max: 20, message: '长度限制为6至20个之间!'},*/}
            {/*{validator: this.checkPassword,}],*/}
            {/*})(*/}
            {/*<Input type="password" onBlur={this.handleConfirmBlur}/>*/}
            {/*)}*/}
            {/*</Form.Item>*/}
            <Form.Item {...tailFormItemLayout}>
                <Button type="primary" onClick={this.handleSubmit}>确认</Button>
            </Form.Item>
        </div>;
        const bindMobile = <div>
            <Tabs tabBarStyle={{ display: 'none' }}
                animated={true}
                activeKey={this.state.mobileActiveKey}
            >
                <Tabs.TabPane key='__1'>
                    <div>
                        <Form.Item
                            {...formItemLayout}
                            label="原始手机号"
                        >
                            {getFieldDecorator('orignalMobile', {
                                rules: [{ required: true, message: '输入你的手机号!' },
                                { pattern: '^1\\d{10}$', message: '手机号格式错误!' }],
                            })(
                                <Input />
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="验证码"
                        >

                            <Input.Group size="large">
                                <Col span={15}>
                                    {getFieldDecorator('orignalCaptcha', {
                                        rules: [
                                            { required: true, message: '请输入验证码!' }
                                        ],
                                    })(
                                        <Input placeholder="验证码" />
                                    )}
                                </Col>
                                <Col span={9}>
                                    <Button type="primary" className="captcha-btn"
                                        onClick={() => this.sendCaptcha('orignalMobile')}
                                        style={{ width: '100%' }}
                                        size="large">
                                        <CountDownText
                                            ref={(captchaTextComp) => {
                                                this.captchaTextComp = captchaTextComp
                                            }}
                                            afterEnd={() => {
                                                this.changeCountingDone(true)
                                            }}
                                            startText='发送验证码'
                                            endText='发送验证码'
                                            timeLeft={60} // 正向计时 时间起点为0秒
                                            intervalText={(sec) => sec + '秒重新获取'} />
                                    </Button>
                                </Col>
                            </Input.Group>
                        </Form.Item>
                        <Form.Item {...tailFormItemLayout}>
                            <Button type="primary" onClick={() => this.prematchCaptcha('orignalMobile', 'orignalCaptcha')}>下一步</Button>
                        </Form.Item>
                    </div>
                </Tabs.TabPane>
                <Tabs.TabPane key='__2'>
                    <div>
                        <Form.Item
                            {...formItemLayout}
                            label="新手机号"
                        >
                            {getFieldDecorator('newMobile', {
                                rules: [{ required: true, message: '输入你的手机号!' },
                                { pattern: '^1\\d{10}$', message: '手机号格式错误!' }],
                            })(
                                <Input />
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="验证码"
                        >

                            <Input.Group size="large">
                                <Col span={15}>
                                    {getFieldDecorator('newCaptcha', {
                                        rules: [
                                            { required: true, message: '请输入验证码!' }
                                        ],
                                    })(
                                        <Input placeholder="验证码" />
                                    )}
                                </Col>
                                <Col span={9}>
                                    <Button type="primary" className="captcha-btn"
                                        onClick={() => this.sendCaptcha('newMobile')}
                                        style={{ width: '100%' }}
                                        size="large">
                                        <CountDownText
                                            ref={(captchaTextComp) => {
                                                this.captchaTextComp = captchaTextComp
                                            }}
                                            afterEnd={() => {
                                                this.changeCountingDone(true)
                                            }}
                                            startText='发送验证码'
                                            endText='发送验证码'
                                            timeLeft={60} // 正向计时 时间起点为0秒
                                            intervalText={(sec) => sec + '秒重新获取'} />
                                    </Button>
                                </Col>
                            </Input.Group>
                        </Form.Item>
                        {userData.data && !userData.data.mobile && !userData.data.email ?
                            <div>
                                <Form.Item
                                    {...formItemLayout}
                                    label="新密码"
                                    hasFeedback
                                >
                                    {getFieldDecorator('password', {
                                        rules: [{
                                            required: true, message: '输入你的密码!',
                                        },
                                        { type: "string", min: 6, max: 20, message: '长度限制为6至20个之间!' },
                                        { validator: this._checkConfirm, }],
                                    })(
                                        <Input type="password" />
                                    )}
                                </Form.Item>
                                <Form.Item
                                    {...formItemLayout}
                                    label="确认密码"
                                    hasFeedback
                                >
                                    {getFieldDecorator('newPassword', {
                                        rules: [{
                                            required: true, message: '输入你的确认密码!',
                                        },
                                        { type: "string", min: 6, max: 20, message: '长度限制为6至20个之间!' },
                                        { validator: this.checkPassword, }],
                                    })(
                                        <Input type="password" onBlur={this.handleConfirmBlur} />
                                    )}
                                </Form.Item>
                            </div>
                            :
                            ""
                        }

                        <Form.Item {...tailFormItemLayout}>
                            <Button type="primary" onClick={() => this.onSubmitReset('mobile')}>确认</Button>
                        </Form.Item>
                    </div>
                </Tabs.TabPane>

            </Tabs>
        </div>
        const bindEmail = <div>
            <Tabs tabBarStyle={{ display: 'none' }}
                animated={true}
                activeKey={this.state.emailActiveKey}
            >
                <Tabs.TabPane key='__1'>
                    <div>
                        <Form.Item
                            {...formItemLayout}
                            label="原始邮箱"
                        >
                            {getFieldDecorator('orignalEmail', {
                                rules: [{ required: true, message: '输入你的邮箱!' },
                                { type: 'email', message: '邮箱格式错误', }],
                            })(
                                <Input />
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="验证码"
                        >

                            <Input.Group size="large">
                                <Col span={15}>
                                    {getFieldDecorator('orignalCaptcha', {
                                        rules: [
                                            { required: true, message: '请输入验证码!' }
                                        ],
                                    })(
                                        <Input placeholder="验证码" />
                                    )}
                                </Col>
                                <Col span={9}>
                                    <Button type="primary" className="captcha-btn"
                                        onClick={() => this.sendCaptcha('orignalEmail')}
                                        style={{ width: '100%' }}
                                        size="large">
                                        <CountDownText
                                            ref={(captchaTextComp) => {
                                                this.captchaTextComp = captchaTextComp
                                            }}
                                            afterEnd={() => {
                                                this.changeCountingDone(true)
                                            }}
                                            startText='发送验证码'
                                            endText='发送验证码'
                                            timeLeft={60} // 正向计时 时间起点为0秒
                                            intervalText={(sec) => sec + '秒重新获取'} />
                                    </Button>
                                </Col>
                            </Input.Group>
                        </Form.Item>
                        <Form.Item {...tailFormItemLayout}>
                            <Button type="primary" onClick={() => this.prematchCaptcha('orignalEmail', 'orignalCaptcha')}>下一步</Button>
                        </Form.Item>
                    </div>
                </Tabs.TabPane>
                <Tabs.TabPane key='__2'>
                    <div>
                        <Form.Item
                            {...formItemLayout}
                            label="新邮箱"
                        >
                            {getFieldDecorator('newEmail', {
                                rules: [{ required: true, message: '输入你的邮箱!' },
                                { type: 'email', message: '邮箱格式错误', }],
                            })(
                                <Input />
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="验证码"
                        >

                            <Input.Group size="large">
                                <Col span={15}>
                                    {getFieldDecorator('newCaptcha', {
                                        rules: [
                                            { required: true, message: '请输入验证码!' }
                                        ],
                                    })(
                                        <Input placeholder="验证码" />
                                    )}
                                </Col>
                                <Col span={9}>
                                    <Button type="primary" className="captcha-btn"
                                        onClick={() => this.sendCaptcha('newEmail')}
                                        style={{ width: '100%' }}
                                        size="large">
                                        <CountDownText
                                            ref={(captchaTextComp) => {
                                                this.captchaTextComp = captchaTextComp
                                            }}
                                            afterEnd={() => {
                                                this.changeCountingDone(true)
                                            }}
                                            startText='发送验证码'
                                            endText='发送验证码'
                                            timeLeft={60} // 正向计时 时间起点为0秒
                                            intervalText={(sec) => sec + '秒重新获取'} />
                                    </Button>
                                </Col>
                            </Input.Group>
                        </Form.Item>
                        {userData.data && !userData.data.mobile && !userData.data.email ?
                            <div>
                                <Form.Item
                                    {...formItemLayout}
                                    label="新密码"
                                    hasFeedback
                                >
                                    {getFieldDecorator('password', {
                                        rules: [{
                                            required: true, message: '输入你的密码!',
                                        },
                                        { type: "string", min: 6, max: 20, message: '长度限制为6至20个之间!' },
                                        { validator: this._checkConfirm, }],
                                    })(
                                        <Input type="password" />
                                    )}
                                </Form.Item>
                                <Form.Item
                                    {...formItemLayout}
                                    label="确认密码"
                                    hasFeedback
                                >
                                    {getFieldDecorator('newPassword', {
                                        rules: [{
                                            required: true, message: '输入你的确认密码!',
                                        },
                                        { type: "string", min: 6, max: 20, message: '长度限制为6至20个之间!' },
                                        { validator: this.checkPassword, }],
                                    })(
                                        <Input type="password" onBlur={this.handleConfirmBlur} />
                                    )}
                                </Form.Item>
                            </div>
                            :
                            ""
                        }
                        <Form.Item {...tailFormItemLayout}>
                            <Button type="primary" onClick={() => this.onSubmitReset('email')}>确认</Button>
                        </Form.Item>
                    </div>
                </Tabs.TabPane>

            </Tabs>
        </div>
        return (
            <ASBody>
                <Tabs className='tabStyle'
                    defaultActiveKey="1"
                    activeKey={this.state.activiKey}
                    tabPosition='left'
                    onChange={val => this.handleChangeTabs(val)}
                >
                    <Tabs.TabPane tab={<span><Icon type="user" />个人信息</span>} key="1">
                        {this.state.activiKey == '1' && <div>
                            {userData.isFetching ? <Spin spinning={userData.isFetching}></Spin> :
                                <div>
                                    <Form.Item
                                        {...formItemLayout}
                                        label="头像"
                                    >
                                        {getFieldDecorator('avatarUrl', {
                                            initialValue: userData.data.avatarUrl,
                                            getValueFromEvent: (fileUrlObj) => {
                                                return fileUrlObj.url;
                                            }
                                        })(
                                            <CkUpload
                                                triggerText=''
                                                icon={<Icon style={{ fontSize: 26, color: '#ddd', marginTop: 5 }} type='user' />}
                                                width={70}
                                                height={70}
                                            />
                                        )}

                                    </Form.Item>
                                    <Form.Item
                                        {...formItemLayout}
                                        label={(
                                            <span>
                                                姓名&nbsp;

                                            </span>
                                        )}
                                        hasFeedback
                                    >
                                        {getFieldDecorator('nickname', {
                                            initialValue: userData.data.nickname,
                                        })(
                                            <Input />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        {...formItemLayout}
                                        hasFeedback
                                        label="QQ"
                                    >
                                        {getFieldDecorator('qq', {
                                            initialValue: userData.data.qq,
                                            rules: [{ type: "string", min: 4, max: 18, message: '长度限制为4至18个之间!' },],
                                        })(
                                            <Input />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        {...formItemLayout}
                                        hasFeedback
                                        label="公司"
                                    >
                                        {getFieldDecorator('company', {
                                            initialValue: userData.data.company,
                                            // rules: [{type: "string", min: 4, max: 18, message: '长度限制为4至18个之间!'},],
                                        })(
                                            <Input />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        {...formItemLayout}
                                        label="性别"
                                        hasFeedback
                                    >
                                        {getFieldDecorator('gender', {
                                            initialValue: userData.data.gender,
                                            rules: [
                                                { required: false, message: '请选择一种性别!' },
                                            ],
                                        })(
                                            <Select style={{ width: '100%' }} placeholder="没有任何选择项" defaultActiveFirstOption={true}>
                                                {
                                                    Object.values(this.props.cmEnums.data.Gender).map((g, index) => {
                                                        return <Select.Option value={g.enumName} key={`gender-${index}`}>{g.enumDesc}</Select.Option>
                                                    })
                                                }
                                            </Select>
                                        )}
                                    </Form.Item>
                                    <Form.Item {...tailFormItemLayout}>
                                        <Button type="primary" onClick={() => this.onSubmit()}>保存</Button>
                                    </Form.Item>
                                </div>}
                        </div>}

                    </Tabs.TabPane>
                    <Tabs.TabPane tab={<span><Icon type="lock" />账户安全</span>} key="2">
                        {this.state.activiKey == '2' && <div>
                            {userData.isFetching ? <Spin spinning={userData.isFetching}></Spin> :
                                <Card title="账户安全" bordered={false} noHovering={true} bodyStyle={{ padding: 0 }}>
                                    <Row style={{ padding: '0 24px', lineHeight: '80px', borderBottom: '1px dotted #ddd' }}>
                                        <Col span={2}>
                                            <Icon type='check' style={{ fontSize: 28, fontWeight: 700, color: '#4eb900', marginTop: 4 }}></Icon>
                                        </Col>
                                        <Col span={3} style={{ fontSize: 16 }}>
                                            登录密码
                                        </Col>
                                        <Col span={16} style={{ color: '#ff1d00', fontSize: 14 }}>
                                            互联网账号存在被盗风险，建议您定期更改密码以保护账户安全。
                                        </Col>
                                        <Col span={3} style={{ textAlign: 'center' }}>
                                            <a href="#" onClick={() => {
                                                userData.data.mobile ? this.showModal('pwd') : message.info('需要先绑定手机或邮箱才能修改密码！')
                                            }}>修改</a>
                                        </Col>
                                    </Row>
                                    <Row style={{ padding: '0 24px', lineHeight: '80px', borderBottom: '1px dotted #ddd' }}>
                                        <Col span={2}>
                                            {userData.data.mobile && userData.data.mobile !== '' ?
                                                <Icon type='check' style={{ fontSize: 28, fontWeight: 700, color: '#4eb900', marginTop: 4 }}></Icon> :
                                                <Icon type='exclamation-circle-o' style={{ fontSize: 28, fontWeight: 700, color: '#ff5303', marginTop: 4 }}></Icon>}

                                        </Col>
                                        <Col span={3} style={{ fontSize: 16 }}>
                                            手机验证
                                        </Col>
                                        <Col span={16} style={{ color: '#898989', fontSize: 14 }}>
                                            <span>{userData.data.mobile && userData.data.mobile !== '' ?
                                                `您验证的手机：${userData.data.mobile} ` :
                                                `验证后，可用于登录和找回密码，接收账户余额变动提醒等。`}
                                            </span>
                                        </Col>
                                        <Col span={3} style={{ textAlign: 'center' }}>
                                            {userData.data.mobile && userData.data.mobile !== '' ?
                                                <span>
                                                    <a href="#" onClick={() => this.showModal('bindMobile')}>修改</a>
                                                    {/*<span className="ant-divider"/>*/}
                                                    {/*<a href="#">解绑</a>*/}
                                                </span> :
                                                <Button onClick={() => this.showModal('bindMobile')}>手机验证</Button>
                                            }

                                        </Col>
                                    </Row>
                                    <Row style={{ padding: '0 24px', lineHeight: '80px', borderBottom: '1px dotted #ddd' }}>
                                        <Col span={2}>
                                            {userData.data.email && userData.data.email !== '' ?
                                                <Icon type='check' style={{ fontSize: 28, fontWeight: 700, color: '#4eb900', marginTop: 4 }}></Icon> :
                                                <Icon type='exclamation-circle-o' style={{ fontSize: 28, fontWeight: 700, color: '#ff5303', marginTop: 4 }}></Icon>}
                                        </Col>
                                        <Col span={3} style={{ fontSize: 16 }}>
                                            邮箱验证
                                        </Col>
                                        <Col span={16} style={{ color: '#898989', fontSize: 14 }}>
                                            <span>{userData.data.email && userData.data.email !== '' ?
                                                `您验证的邮箱：${userData.data.email} ` :
                                                `验证后，可用于登录和找回密码，接收账户余额变动提醒等。`}
                                            </span>
                                        </Col>
                                        <Col span={3} style={{ textAlign: 'center' }}>
                                            {userData.data.email && userData.data.email !== '' ?
                                                <span>
                                                    <a href="#" onClick={() => this.showModal('bindEmail')}>修改</a>
                                                    {/*<span className="ant-divider"/>*/}
                                                    {/*<a href="#">解绑</a>*/}
                                                </span> :
                                                <Button onClick={() => this.showModal('bindEmail')}>邮箱验证</Button>
                                            }
                                        </Col>
                                    </Row>
                                </Card>}
                        </div>}

                    </Tabs.TabPane>

                    <Tabs.TabPane tab={<span><Icon type="aliwangwang-o" />登录会话</span>} key="3">

                        <div>
                            {
                                this.state.userTokens ? this.state.userTokens.sort((a, b) => a.accessTime < b.accessTime).map((token, tokenindex) => {


                                    const loginedUserToken = localStorage.getItem('token')
                                    const isSameLoingedToken = loginedUserToken == token.token;

                                    const popconfirmTitle = <span>您确定要踢出此会话吗?
                                            <span className="mdc-text-red">({this.props.cmEnums.data.LoginType[token.principal.loginType].enumDesc}方式登录)</span>
                                    </span>;

                                    return <Card key={`pooperidkwqxxxi34d${tokenindex}`}>
                                        {isSameLoingedToken ? <p style={{ fontSize: 14, color: "#f50" }}>本机</p> : null}
                                        {/*<p style={{wordBreak: "break-all"}}>{token.token}</p>*/}
                                        <p><span style={{ display: "inline-block", width: 85, fontWeight: 600 }}>登录方式:</span>{this.props.cmEnums.data.LoginType[token.principal.loginType].enumDesc}</p>
                                        <p><span style={{ display: "inline-block", width: 85, fontWeight: 600 }}>最近访问时间:</span>{token.accessTime}</p>

                                        {!isSameLoingedToken ?
                                            <Popconfirm title={popconfirmTitle}
                                                placement="leftBottom"
                                                onConfirm={(e) => {
                                                    kickOnlineUserToken({ userId: "default", token: token.token }).then(res => {
                                                        if (res.code == 200) {
                                                            message.success('踢出成功!');
                                                            if (isSameLoingedToken) {
                                                                clearAuth(true);
                                                            } else {
                                                                this.findDefaultOnlineUserTokens()
                                                            }
                                                        } else {
                                                            message.error(res.msg,6);
                                                        }
                                                    }).catch(err => {
                                                        message.warn("访问异常");
                                                    })
                                                }}
                                                okText="踢出"
                                                cancelText="放弃">
                                                <a style={{ position: "absolute", bottom: 24, right: 24 }}>踢出</a>
                                            </Popconfirm>
                                            :
                                            null
                                        }
                                    </Card>
                                })
                                    :
                                    <Spin spinning={true}></Spin>
                            }

                            <div style={{ textAlign: "center" }}>

                                <Button icon="reload" type="primary" onClick={this.findDefaultOnlineUserTokens} style={{ marginRight: 25 }}>刷新</Button>
                                {isSuperuser(this.props.loginedUser) &&
                                    <span>
                                        &nbsp;&nbsp;
                                        <Button icon="reload" type="primary" onClick={() => this.handleTokenModalVisible(true)} style={{ marginRight: 25 }}>更换token</Button>
                                    </span>
                                }
                                {
                                    this.state.userTokens && this.state.userTokens.length > 1 ?

                                        <Popconfirm title={<span>您确定要踢出踢出除本机外的其他所有会话吗?</span>}
                                            placement="top"
                                            onConfirm={(e) => {
                                                kickOnlineUserExcludeOneself().then(res => {
                                                    if (res.code == 200) {
                                                        this.findDefaultOnlineUserTokens();
                                                    } else {
                                                        message.error(res.msg,6);
                                                    }
                                                }).catch(err => {
                                                    message.warn("访问异常");
                                                })
                                            }}
                                            okText="踢出"
                                            cancelText="放弃">
                                            <Button
                                                type="primary"
                                            >
                                                踢出除本机外的其他所有会话
                                            </Button>
                                        </Popconfirm>
                                        :
                                        null
                                }

                            </div>
                        </div>

                    </Tabs.TabPane>
                    <Tabs.TabPane tab={<span><Icon type="environment-o" />收货地址</span>} key="4">
                        <UserAddressesSetting userId={"default"} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={<span><Icon type="message" />短信签名</span>} key="5">
                        <UserSmssignSetting />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={<span><Icon type="credit-card" />发票信息</span>} key="6">
                        <Row>
                            <Col span={24}>
                                <Form.Item
                                    {...formItemLayout}
                                    label="发票抬头"
                                    hasFeedback
                                    extra={"个人名称或公司名称"}
                                >
                                    {getFieldDecorator('companyName', {
                                        initialValue: invBook.data.companyName,
                                        rules: [{ required: true, message: '请填写个人名称或公司名称!' }, { whitespace: true, message: '不能输入空格!' }, { min: 2, max: 100, message: '长度限制为1至20个之间!' }],
                                    })(
                                        <Input />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    {...formItemLayout}
                                    label="纳税人识别号"
                                    hasFeedback
                                    extra={"个人或政府部门无税号请填写：0"}
                                >
                                    {getFieldDecorator('companyTaxNo', {
                                        initialValue: invBook.data.companyTaxNo,
                                        rules: [{ required: true, message: '请填写纳税人识别号!' }, { pattern: BizRegex.noblank, message: '不能输入空格!' }, { min: 1, max: 20, message: '长度限制为1至20个之间!' }],
                                    })(
                                        <Input />
                                    )}
                                </Form.Item>

                            </Col>
                            <Col span={24}>

                                <Form.Item
                                    {...formItemLayout}
                                    label="公司开票地址"
                                    hasFeedback
                                >
                                    {getFieldDecorator('companyAddress', {
                                        initialValue: invBook.data.companyAddress,
                                        rules: [{ whitespace: true, message: '不能输入空格!' }, { min: 2, max: 500, message: '长度限制为2至500个之间!' }],
                                    })(
                                        <Input placeholder="增值税专票必填" />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={24}>

                                <Form.Item
                                    {...formItemLayout}
                                    label="公司电话"
                                    hasFeedback
                                >
                                    {getFieldDecorator('companyPhone', {
                                        initialValue: invBook.data.companyPhone,
                                        rules: [{ pattern: BizRegex.phone, message: '长度限制为5至20个之间，支持：数字,-,+和()' }],
                                    })(
                                        <Input placeholder="增值税专票必填" />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={24}>

                                <Form.Item
                                    {...formItemLayout}
                                    label="开户行"
                                    hasFeedback
                                >
                                    {getFieldDecorator('bankName', {
                                        initialValue: invBook.data.bankName,
                                        rules: [{ whitespace: true, message: '不能输入空格!' }, { min: 2, max: 100, message: '长度限制为2至100个之间!' }],
                                    })(
                                        <Input placeholder="增值税专票必填" />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={24}>

                                <Form.Item
                                    {...formItemLayout}
                                    label="银行帐号"
                                    hasFeedback
                                >
                                    {getFieldDecorator('bankAccount', {
                                        initialValue: invBook.data.bankAccount,
                                        rules: [{ pattern: BizRegex.noblank, message: '不能输入空格!' }, { min: 8, max: 24, message: '长度限制为8至24个之间!' }],
                                    })(
                                        <Input placeholder="增值税专票必填" />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item {...tailFormItemLayout}>
                                    <Button type="primary" onClick={() => this.onInvoiceSubmit()}>保存</Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={<span><Icon type="team" />子账号管理</span>} key="7">
                        <SubAccounts></SubAccounts>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={<span><Icon type="layout" />子账号活动申请</span>} key="11">
                        <SubAccountEvtApplyList />
                    </Tabs.TabPane>
                    {/* <Tabs.TabPane tab={<span><Icon type="layout" />微信第三方授权</span>} key="12">
                        <WxAuthorization />
                    </Tabs.TabPane> */}
                    {
                        localStorage.getItem('userId') == '1244480807142166530' &&
                        <Tabs.TabPane tab={<span><Icon type="setting" />学分配置</span>} key="9">
                            <CreditSystemConfigs />
                        </Tabs.TabPane>}
                    {
                        localStorage.getItem('userId') == '1244480807142166530' &&
                        <Tabs.TabPane tab={<span><Icon type="bar-chart" />学分统计</span>} key="10">
                            <CreditSystemStatus />
                        </Tabs.TabPane>
                    }

                    <Tabs.TabPane tab={<span><Icon type="poweroff" />注销账号</span>} key="8">
                        <WFBody>
                            <h5>申请注销账号</h5>
                            <p>您提交的注销申请生效前，请保证您的数据及财产安全：</p>
                            <div>
                                <span></span>
                                数据安全
                            </div>
                            <p>您的数据，包括不限于活动、投票、抽奖、通讯录等数据已导出保存</p>
                            <div>
                                <span></span>
                                财产安全
                            </div>
                            <p>您的财产，包括但不限于钱包余额、签币余额、红包余额等财产已全部处理</p>
                            <Button type="primary" size={'large'} style={{ marginTop: 30 }} onClick={() => this.handleWFModalVisible(true)}>申请注销</Button>
                        </WFBody>
                    </Tabs.TabPane>
                </Tabs>
                <Modal
                    // width={1000}
                    title={<span>
                        {this.state.type == 'pwd' && '密码修改'}
                        {this.state.type == 'bindMobile' && '手机修改'}
                        {this.state.type == 'bindEmail' && '邮箱修改'}
                    </span>}
                    visible={this.state.visible}
                    onCancel={this.handleCancel}
                    footer={null}
                >
                    {this.state.visible && this.state.type == 'pwd' && changePwd}
                    {this.state.visible && this.state.type == 'bindMobile' && bindMobile}
                    {this.state.visible && this.state.type == 'bindEmail' && bindEmail}
                </Modal>
                <Modal
                    title="更换token"
                    visible={this.state.tokenModalVisible}
                    onCancel={() => this.handleTokenModalVisible(false)}
                    onOk={this.handleTokenSubmit}
                >
                    <Input.TextArea rows={3} value={this.state.tokenValue} onChange={(e) => this.setState({ tokenValue: e.target.value })} />
                </Modal>
                <Modal
                    title="注销须知"
                    visible={this.state.wfModalVisible}
                    onCancel={() => this.handleWFModalVisible(false)}
                    onOk={() => {
                        if (userData.data && userData.data.mobile) {
                            this.handleWFCapVisible(true)
                        } else {
                            this.onSumbitWF()
                        }
                    }}
                >
                    <WFModal>
                        <div>注销签到家账号是不可恢复的操作，您应自行备份账号相关的信息和数据。操作之前，请确认与签到家账号相关的所有服务均已进行妥善处理。
                        </div>
                        <div>
                            请谨记：注销账号，您将无法再使用本账号或找回您添加或绑定的任何内容或信息（即使您使用相同的手机号或账号再次申请并使用），包括但不限于：
                        </div>
                        <p>
                            1. 您将无法登录、使用本账号。
                        </p>
                        <p>
                            2. 您的账号的个人信息（包含但不限于：昵称、头像、二维码、签币、现金、活动、投票、大屏互动等等账号相关数据）都将无法找回。
                        </p>
                        <p>
                            3. 注销账号前，您需妥善处理其账户下的所有资金问题。
                        </p>
                        <p>
                            4. 注销您的账号并不代表本账号注销之前的账号行为和相关责任得到豁免或减轻。
                        </p>
                        <h5>
                            *申请注销后，符合允许条件，注销即刻生效。
                        </h5>
                        <h5>
                            注意：如微信直接登录，未绑定手机或邮件的用户点击确认后注销立马生效，绑定了手机或邮件的用户需验证后注销生效。
                        </h5>
                    </WFModal>
                </Modal>
                {this.state.wfCapVisible &&
                    <Modal
                        title="手机验证"
                        visible={true}
                        onCancel={() => this.handleWFCapVisible(false)}
                        onOk={this.getWFCaptcha}
                    >
                        <Form.Item
                            {...formItemLayout}
                            label="手机号"
                        >
                            {getFieldDecorator('mobile', {
                                initialValue: userData.data.mobile,
                                rules: [{ required: true, message: '输入你的手机号!' },
                                { pattern: '^1\\d{10}$', message: '手机号格式错误!' }],
                            })(
                                <Input disabled={true} />
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="验证码"
                        >

                            <Input.Group size="large">
                                <Col span={15}>
                                    {getFieldDecorator('captcha', {
                                        rules: [
                                            { required: true, message: '请输入验证码!' }
                                        ],
                                    })(
                                        <Input placeholder="验证码" />
                                    )}
                                </Col>
                                <Col span={9}>
                                    <Button type="primary" className="captcha-btn"
                                        onClick={() => this.sendWFCaptcha()}
                                        style={{ width: '100%' }}
                                        size="large">
                                        <CountDownText
                                            ref={(captchaTextComp) => {
                                                this.captchaTextComp = captchaTextComp
                                            }}
                                            afterEnd={() => {
                                                this.changeCountingDone(true)
                                            }}
                                            startText='发送验证码'
                                            endText='发送验证码'
                                            timeLeft={60} // 正向计时 时间起点为0秒
                                            intervalText={(sec) => sec + '秒重新获取'} />
                                    </Button>
                                </Col>
                            </Input.Group>
                        </Form.Item>
                    </Modal>}
            </ASBody>

        )
    }
}

AccountSettings.defaultProps = {
    visibleHide: () => null,

};
const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    const loginedUser = state.loginedUser;
    return { cmEnums, loginedUser };
};
const mapDispatchToProps = dispatch => ({
    fetchLoginedUser: bindActionCreators(fetchLoginedUser, dispatch),
    fetchUserAddresses: bindActionCreators(fetchUserAddresses, dispatch),
});


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(AccountSettings));



// WEBPACK FOOTER //
// ./src/containers/usersfrom/AccountSettings.jsx